var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-center align-center"},[_c('div',{staticClass:"dt-avatar-preview"},[_c('v-avatar',{attrs:{"size":"160"}},[_c('img',{attrs:{"src":_vm.dataset.avatar,"alt":""}})])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }